export const COMMON_QUERY_KEY = {
  FETCH_STATE: 'state',
  FETCH_COUNTRY: 'country',
  GET_EQUIPMENTS_DROPDOWN: 'get_equipments_dropdown',
  FETCH_GEOCODE_ADDRESS: 'fetchGeocodeAddress',
  GET_STONLY_DATA: 'get_stonly_data',
  GET_TENANT_INFORMATION: 'get_tenant_information',
  RESET_TENANT_ONBOARDING_SKIP: 'reset_tenant_onboarding_skip',
} as const;
